import { blue, gray } from "@ant-design/colors";
import { type AppAvatarProps } from "@lib/components/AppComponents/AppAvatar";
import { getContrastColor } from "@lib/helpers/ColorHelper";
import { type AvatarSize } from "@lib/types/General";
import { Avatar } from "antd";
import styled, { css } from "styled-components";

const getSize = (size: AvatarSize) => {
  if (size === "xx-small") return 16;
  if (size === "x-small") return 20;
  if (size === "small") return 24;
  if (size === "large") return 48;
  if (size === "x-large") return 64;
  if (size === "xx-large") return 80;
  return 32;
};

export const StyledAppAvatar = styled(Avatar)<AppAvatarProps>`
  background-color: #fff;
  color: ${() => gray[6]};

  ${({ children, theme }) =>
    children &&
    css`
      background-color: ${theme?.palette.primary.main || "#fff"} !important;
      color: ${getContrastColor(
        theme?.palette.primary.main || "#fff",
      )} !important;
    `}

  ${({ border }: any) =>
    border &&
    css`
      border-color: ${border?.color || blue[4]} !important;
      border-width: ${border?.width || 2}px !important;
      border-style: ${border?.borderStyle || "solid"} !important;
    `}

  ${({ size }) =>
    size &&
    css`
      width: ${getSize(size)}px !important;
      height: ${getSize(size)}px !important;
      font-size: ${getSize(size)}px !important;
      border-width: ${getSize(size) / 12}px !important;
    `}

  img {
    ${({ objectFit }) =>
      objectFit &&
      css`
        object-fit: ${objectFit} !important;
      `}
  }

  svg {
    color: ${() => gray[3]} !important;
  }
`;
